var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[(_vm.isShow)?_c('ui-card',{staticClass:"py-6",attrs:{"flat":false}},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }